module.exports = __webpack_public_path__ + "images/application/i-warning-dark-edb607c1.svg";